<template>
  <v-layout justify-end>
    <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
       <v-icon dark left>note_add</v-icon>New Item
    </v-btn>
    <v-dialog v-model="localDialog" persistent max-width="1500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex>
                  <image-uploader
                    v-bind:constImage="local.image"
                    v-bind:dialog="dialog"
                    @image="assignImage">
                  </image-uploader>
                  <v-text-field
                    label="Name"
                    v-model="local.name"
                    :rules="generalRules"
                    required>
                  </v-text-field>
                  <v-text-field
                    label="Prefab name"
                    v-model="local.prefabName"
                    :rules="generalRules"
                    required>
                  </v-text-field>
                  <v-text-field
                    v-model="local.service"
                    label="Service (Optional)">
                  </v-text-field>
                  <v-textarea
                    label="Description (Optional)"
                    v-model="local.description">
                  </v-textarea>

                  <v-select
                    :items="effectTypes"
                    v-model="local.effectType"
                    label="Select Effect Type"
                    :rules="generalRules"
                    required
                    chips
                    persistent-hint>
                  </v-select>
                  <br>
                </v-flex>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>
                <v-flex>
                  <popover :always="true">
                    <h3>Position of Origin</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.positionOfOrigin.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.positionOfOrigin.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.positionOfOrigin.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <popover :always="true">
                    <h3>Rotation of Origin</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.rotationOfOrigin.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.rotationOfOrigin.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.rotationOfOrigin.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <popover :always="true">
                    <h3>Scale of Origin</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.scaleOfOrigin.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.scaleOfOrigin.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.scaleOfOrigin.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-text-field
                    v-model="local.duration"
                    label="Duration (sec)"
                    type="number">
                  </v-text-field>
                  <v-select
                    :items="identifiableSurfaces"
                    v-model="local.identifiableSurface"
                    label="Select Identifiable Surface"
                    chips
                    persistent-hint>
                  </v-select>
                  <v-text-field
                    v-model="local.movementElement"
                    label="Movement Element">
                  </v-text-field>
                </v-flex>
                <v-spacer/>
                <v-flex>
                  <!--                  test-->
                  <h3>Attachments</h3>
                  <!-- <file-uploader
                    @input="assignFBX"
                    v-model="local.fbx">
                    <div slot="activator">
                      <v-text-field
                        label="Filmbox"
                        v-model="local.fbx.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required="false">
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <file-uploader
                    @input="assignIOS"
                    v-model="local.asset_bundle.iOS">
                    <div slot="activator">
                      <v-text-field
                        label="iOS Asset Bundle"
                        v-model="local.asset_bundle.iOS.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required="false"
                      >
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <file-uploader
                    @input="assignAndroid"
                    v-model="local.asset_bundle.Android">
                    <div slot="activator">
                      <v-text-field
                        label="Android Asset Bundle"
                        v-model="local.asset_bundle.Android.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required="false"
                      >
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <file-uploader
                    @input="assignWebGL"
                    v-model="local.asset_bundle.WebGL">
                    <div slot="activator">
                      <v-text-field
                        label="WebGL Asset Bundle"
                        v-model="local.asset_bundle.WebGL.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required="false">
                      </v-text-field>
                    </div>
                  </file-uploader> -->
                  <h3>Allowed Sound</h3>
                  <v-radio-group v-model="local.allow_sound" row>
                    <v-radio :label="'Yes'" :value="true"></v-radio>
                    <v-radio :label="'No'" :value="false"></v-radio>
                  </v-radio-group>
                  <v-checkbox
                    v-model="local.loop"
                    label="Loops">
                  </v-checkbox>
                  <!-- <h3>Type of Component</h3>
                  <v-radio-group v-model="local.componentType" row>
                    <v-radio :label="componentType.threeD" :value="componentType.threeD"></v-radio>
                    <v-radio :label="componentType.character" :value="componentType.character"></v-radio>
                    <v-radio :label="componentType.standalone" :value="componentType.standalone"></v-radio>
                  </v-radio-group> -->
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="close">Cancel</v-btn>
          <v-btn color="primary" v-if="showSaveButton" @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ImageUploader from '../uploader/imageUploader'
import FileUploader from '../uploader/fileUploader'
import {db} from '../../../firebaseDB'

export default {
  name: 'addNew',
  components: { ImageUploader, FileUploader },
  data: () => ({
    valid: true,
    errorMsg: '',
    saving: false,
    generalRules: [
      v => !!v || 'This field is required'
    ],
    positiveNumber: [
      v => v >= 0.01 || 'This field should be greater than 0'
    ],
    componentType: {
      threeD: '3D',
      character: 'Character',
      standalone: 'Standalone'
    },
    effectTypes: ['2D', '3D'],
    sounds: [],
    identifiableSurfaces: [],
    local: {
      id: '',
      image: null,
      name: '',
      service: '',
      description: '',
      effectType: '',
      allow_sound: true,
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        WebGL: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      loop: 0,
      duration: 0,
      identifiableSurface: '',
      movementElement: ''
      // componentType: 'Character'
    }
  }),
  props: {
    dialog: '',
    editedID: '',
    showSaveButton: true,
    info: {
      id: null,
      name: '',
      prefabName: '',
      service: '',
      description: '',
      image: null,
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      is3DEffect: '',
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      numberOfLoops: 0,
      duration: 0,
      identifiableSurface: '',
      movementElement: ''
    }
  },
  created () {
    db.ref('assets/asset_data/sound')
      .once('value')
      .then(snapshot => {
        Object.keys(snapshot.val())
          .forEach(k => this.sounds.push({
            id: k,
            name: snapshot.val()[k].name || k
          }))
      })
      .catch(error => {
        console.log('Error - ' + error.message)
      })
  },
  computed: {
    formTitle () {
      return this.editedID === -1 ? 'New Visual Effects' : this.showSaveButton ? 'Edit Visual Effects' : 'Preview Visual Effects'
    },
    localDialog: {
      get: function () {
        return this.dialog
      }
    }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
      if (!this.local.hasOwnProperty('fbx')) {
        this.local.fbx = {
          fileName: '',
          file: '',
          fileURL: ''
        }
      }
      if (!this.local.hasOwnProperty('asset_bundle')) {
        this.local.asset_bundle = {
          iOS: {
            fileName: '',
            file: '',
            fileURL: ''
          },
          Android: {
            fileName: '',
            file: '',
            fileURL: ''
          }
        }
      }
    },
    dialog (val) {
      if (!val) {
        this.saving = false
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm () {
      this.$refs.form.resetValidation()
    },
    validateForm () {
      return this.$refs.form.validate()
    },
    assignImage (payload) {
      this.local.image = payload
    },
    assignFBX (payload) {
      this.local.fbx = payload
    },
    assignIOS (payload) {
      this.local.asset_bundle.iOS = payload
    },
    assignAndroid (payload) {
      this.local.asset_bundle.Android = payload
    },
    assignWebGL (payload) {
      this.local.asset_bundle.WebGL = payload
    },
    open () {
      this.$emit('open')
    },
    close () {
      this.$emit('close')
    },
    save () {
      if (this.validateForm()) {
        this.saving = true
        this.$emit('save', this.local)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addEffect.vue